import * as React from 'react';

import { angularProviderHOC } from '../../../../common/react/AngularProviderHOC';
import { ReactDirectiveProps } from '../../../../ts/directives/reactDirectiveFactory';
import { BrowserTitleService } from '../../../../ts/services/BrowserTitleService';
import { Telemetry } from '../../../../ts/services/TelemetryService';
import { ServiceLocator } from '../../../ServiceLocator';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../../RouterHelpers/SpaceInfoProvider';
import { ConnectedAllSitesSpace } from './ConnectedAllSitesSpace';

export interface AllSitesSpaceProviderProps extends ReactDirectiveProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
}

export interface AllSitesSpaceAngularProps {
  readonly browserTitleService: BrowserTitleService;
  readonly telemetry: Telemetry;
}

const AllSitesSpaceAngularHOC = angularProviderHOC<ReactDirectiveProps, AllSitesSpaceAngularProps, AllSitesSpaceAngularProps>({
  getAngularServicesWithServiceLocator: () => ({
    browserTitleService: ServiceLocator.get<BrowserTitleService>('BrowserTitleService'),
    telemetry: ServiceLocator.get<Telemetry>('TelemetryService'),
  }),
  selectPropsFromAngularServices: angularServices => angularServices,
});

const AngularWrappedConnectedAllSitesSpace: React.ComponentType<ReactDirectiveProps>
  = AllSitesSpaceAngularHOC(ConnectedAllSitesSpace);

const AllSitessSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'sites',
  subspaceName: undefined
};

export const AllSitesSpaceProvider: React.FunctionComponent<AllSitesSpaceProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={AllSitessSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={false}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <AngularWrappedConnectedAllSitesSpace angularContext={props.angularContext}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};
